var React = require('react');

function Lock (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"28","cy":"28","r":"28","fill":"#5668F1","key":0}),React.createElement("rect",{"x":"17.0001","y":"24","width":"22","height":"18","rx":"4","stroke":"#EBECF7","strokeWidth":"2","key":1}),React.createElement("path",{"d":"M33 24V19C33 16.2386 30.7614 14 28 14C25.2386 14 23 16.2386 23 19V24","stroke":"#EBECF7","strokeWidth":"2","key":2}),React.createElement("path",{"d":"M28 29C29.1045 29 29.9999 29.8955 30 31C30 31.6689 29.6703 32.259 29.166 32.6221L29.9199 36.5762C29.9618 36.7962 29.7924 37 29.5684 37H26.4316C26.2078 36.9998 26.0392 36.7961 26.0811 36.5762L26.834 32.6221C26.33 32.2589 26 31.6687 26 31C26.0001 29.8957 26.8957 29.0002 28 29Z","fill":"#EBECF7","key":3})]);
}

Lock.defaultProps = {"width":"56","height":"56","viewBox":"0 0 56 56","fill":"none"};

module.exports = Lock;

Lock.default = Lock;
